import * as i0 from "@angular/core";
export class ImageStore {
}
ImageStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ImageStore_Factory() { return new ImageStore(); }, token: ImageStore, providedIn: "root" });
export var ImageStoreKeys;
(function (ImageStoreKeys) {
})(ImageStoreKeys || (ImageStoreKeys = {}));
